import api from '@/api'

export default class ConfigurationService {
  retrieveConfiguration () {
    return api.get('parameters')
      .then((response) => {
        return new Promise((resolve) => { resolve(response.data) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/configurationService.js